/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 4;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   * @param {string} variantId - The exact supplier-linked variant that was viewed.
   */
  static addProduct(productId, variantId) {
    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter(
      (/** @type {{ productId: string, variantId: string }} */ item) =>
        item.productId !== productId || item.variantId !== variantId
    );
    viewedProducts.unshift({ productId, variantId });
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {{ productId: string, variantId: string }[]} The list of viewed listings.
   */
  static getProducts() {
    const storedProducts = JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');

    return storedProducts
      .map((item) => {
        if (typeof item === 'string') return { productId: item, variantId: '' };
        return {
          productId: String(item?.productId || ''),
          variantId: String(item?.variantId || ''),
        };
      })
      .filter((item) => item.productId);
  }
}
